<mat-card appearance="outlined" class="cdn-card">
  @if (cdnVhost$ | async; as data) {
    <div class="header row">
      <div>
        <h2>CDN Vhost</h2>
        <span>ID {{ data.id }}</span>
      </div>
      <div class="space row">
        <app-status-label [status]="toStatus(data.status)"></app-status-label>
        <button matRipple class="menu button" [matMenuTriggerFor]="menu">
          <fa-icon [icon]="['fas', 'ellipsis-vertical']" size="lg"></fa-icon>
        </button>

        <mat-menu #menu="matMenu">
          @if (xdnEnabled()) {
            <button mat-menu-item (click)="disableXDNFeatures()">
              <fa-icon [icon]="['fas', 'pause']" size="sm"></fa-icon>
              <span>Disable CDN Vhost</span>
            </button>
          } @else {
            <button mat-menu-item (click)="enableXDNFeatures()">
              <fa-icon [icon]="['fas', 'play']" size="sm"></fa-icon>
              <span>Enable CDN Vhost</span>
            </button>
          }
          <button mat-menu-item class="red" (click)="deleteCDN()">
            <fa-icon [icon]="['fas', 'trash']" size="sm"></fa-icon>
            <span>Delete CDN Vhost</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="elevated row">
      <div class="column">
        <h5>CDN Records</h5>
        <span>The website is using Origin Server DNS Records.</span>
      </div>
      <mat-slide-toggle
        [checked]="cdnEnabled()"
        (change)="onCDNToggleChange($event)"
        [disabled]="loadingCDN()"
      ></mat-slide-toggle>
    </div>

    <div class="elevated row">
      <div class="column">
        <h5>CDN IP Addresses</h5>
        @for (ip of data.serverIps; track $index) {
          <div class="ip row">
            <button class="copy button" [cdkCopyToClipboard]="ip.serverIp">
              <fa-icon [icon]="['far', 'copy']" size="lg"></fa-icon>
            </button>
            <span>{{ ip.serverIp }}</span>
          </div>
        }
      </div>
      <button matButton="outlined" [cdkCopyToClipboard]="(dnsRecordsText$ | async) || ''">
        <fa-icon [icon]="['fas', 'copy']" size="lg"></fa-icon>
        Copy DNS records
      </button>
    </div>

    @if (cdnEnabled()) {
      <div class="elevated row">
        <div class="column">
          <h5>CDN Caching</h5>
          <span
            >The CDN Caching is {{ cdnCachingEnabled() ? 'enabled' : 'disabled' }} for this
            website.</span
          >
        </div>
        <mat-slide-toggle
          [checked]="cdnCachingEnabled()"
          (change)="onCDNCacheToggleChange($event)"
          [disabled]="loadingCDNCaching()"
        ></mat-slide-toggle>
      </div>
    }

    <div class="buttons row">
      <button matButton="filled" (click)="clearCache()">
        <fa-icon [icon]="['fas', 'eraser']" size="lg"></fa-icon>
        Clear CDN Cache
      </button>

      <button matButton="outlined" (click)="openCDNFeaturesDialog()">
        <fa-icon [icon]="['fas', 'cloud']" size="lg"></fa-icon>
        CDN Features
      </button>
    </div>
  } @else {
    <h2>CDN Vhost</h2>
    <span>This website does not have CDN Vhost in VMAX yet.</span>
    <button matButton="filled" id="add-cdn" (click)="addCDN()">
      <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
      Add CDN Vhost
    </button>
  }
</mat-card>
